export default __webpack_public_path__ + "static/media/newOfferStatusIcon.57740da9.svg";